import styled from '@emotion/styled';
import Button, { ButtonProps } from '@portalterreno/react-ui-core/Button';

export type StyledShareButtonProps = ButtonProps;

const StyledShareButton = styled(Button)<StyledShareButtonProps>({
  paddingRight: 0,
  paddingLeft: '6px'
});

export default StyledShareButton;
